"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _identity = _interopRequireDefault(require("lodash/fp/identity"));
var _prop = _interopRequireDefault(require("lodash/fp/prop"));
var _curryRight = _interopRequireDefault(require("lodash/fp/curryRight"));
var _LocaleContext = require("@active/react-utils/i18n/LocaleContext");
var _connectForm = _interopRequireDefault(require("../Form/connectForm"));
var _connectFormGroup = _interopRequireDefault(require("../FormGroup/connectFormGroup"));
var _FormFieldWrapper = _interopRequireDefault(require("../FormField/FormFieldWrapper"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var FormStaticField = function FormStaticField(_ref) {
  var i18n = _ref.i18n,
    _ref$formatter = _ref.formatter,
    formatter = _ref$formatter === void 0 ? _identity["default"] : _ref$formatter,
    value = _ref.value;
  return /*#__PURE__*/_react["default"].createElement(_FormFieldWrapper["default"], {
    className: "form-field-static"
  }, formatter(value, i18n));
};
var FormStaticFieldContainer = (0, _compose["default"])(_LocaleContext.withI18n, _connectFormGroup["default"], (0, _curryRight["default"])(_connectForm["default"])(function (_ref2, _ref3) {
  var getFieldProps = _ref2.form.getFieldProps;
  var name = _ref3.name;
  return {
    value: (0, _prop["default"])('value')(getFieldProps === null || getFieldProps === void 0 ? void 0 : getFieldProps({
      name: name
    }))
  };
}), _react.memo)(FormStaticField);
var _default = exports["default"] = FormStaticFieldContainer;